const changeLog = [
  {
    version: "05.04.05",
    issues: [
      {id: "ITRACEV5-80", description: "Added support for parsing out posting errors so they can be displayed in the grid as a separate section (to make them easier to identify)."},
      {id: "ITRACEV5-62", description: "Modified App Title."},
    ]
  },
  {
    version: "05.04.04",
    issues: [
      {id: "ITRACEV5-CORE", description: "Fixed issue where conversion to Despatch Advice PO Entity LineItemNumber was not displaying a null node (it was being removed)."},
      {id: "ITRACEV5-75", description: "Fixed defect where History Grid detail was showing repost as true when record had not been reposted."},
      {id: "ITRACEV5-65", description: "Send user a message that repost has started so user knows the repost was initiated."}
    ]
  }
];

export default changeLog;
